import { required } from 'vuelidate/lib/validators';

const validations = {
  title: {
    required,
  },
  displayName: {
    required,
  },
  attributeStyle: {
    required,
  },
  attributeProperties: {
    required,
  }
};

export default validations;